import { atom } from "recoil";

export const schedulerState = atom({
  key: "schedulerState",
  default: {
    pages: [],
    calendars: [],
  },
});
